import React from 'react'
import './CuttingEdge.css'

const CuttingEdge = () => {
  return (
    <>

    <section className='cutting-section' >
        <div className="cutting-wrapper   ">

            <div className="cutting-headline-wrapper absolute-center flex flex-col ">
                <div className="cutting-headline absolute-center max-width">CUTTING EDGE TECHNOLOGY</div>

                <div className="cutting-para-wrapper">
                <span className="cutting-para absolute-center flex flex-col">
          <div className="absolute-center">PEAK PERFORMANCE</div>
          <div className="absolute-center">MEETS UNMATCHED</div>
          <div className="absolute-center">ELEGANCE</div>
                </span>
                </div>
            </div>




        </div>

    </section>

    </>
  )
}

export default CuttingEdge